export class Email {
    nombre: string;
    email: string;
    tipoConsulta: string;
    mensaje: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/landingPage/email.ts